import { cn, IconButton, IconType } from "@cca/components";
import { Feature } from "@core/enums";
import { NavLink, useLocation } from "react-router-dom";

export type SidebarNavigationItemProps = {
  icon: IconType;
  to: string | string[];
  name: string;
  hideName?: boolean;
  features: Feature | Feature[];
};

const SidebarNavigationItem = ({
  icon,
  to,
  name,
  hideName,
}: SidebarNavigationItemProps) => {
  const location = useLocation();

  return (
    <li>
      <NavLink
        aria-label={hideName ? name : undefined}
        className={({ isActive }) =>
          cn(
            "group flex h-10 items-center gap-2 rounded-lg text-gray-700 transition-all duration-300 ease-in-out hover:no-underline",
            {
              "bg-blue-50 text-blue-600": Array.isArray(to)
                ? to.some((path) => location.pathname.startsWith(path))
                : isActive,
              "hover:bg-gray-50 hover:text-gray-700": !isActive,
            },
          )
        }
        to={Array.isArray(to) ? to[0] : to}
      >
        <IconButton
          as="span"
          className="pointer-events-none text-inherit duration-100 md:text-base"
          icon={icon}
        />
        {!hideName && (
          <span className="truncate text-sm font-bold text-inherit">
            {name}
          </span>
        )}
      </NavLink>
    </li>
  );
};

export default SidebarNavigationItem;
